export default {
	props: {
		booleanType: {
			type: String,
			default: 'checkbox'
		}
	},
	data() {
		return {
			booleanDefaultValue: 1
		};
	},
	computed: {
		booleanValue() {
			if (typeof this.value === 'number') return !!this.value;
			return this.value;
		}
	},
	methods: {
		booleanParseDefaultValue() {
			if (this.defaultValue !== null) return this.booleanParseValue(this.defaultValue);
			return this.booleanDefaultValue;
		},
		booleanParseValue(value) {
			if (typeof value === 'number') return value;
			return value ? 1 : 0;
		},
		booleanChange(e) {
			const parsedValue = this.parseValue(e.target.checked);
			this.$emit('input', parsedValue);
		}
	}
};
